import { canSuggestBag } from './cabin-checks';
import { assignItemToBag, deriveBagLoads } from './readiness';
import type { PackingState } from './schema';
export interface BagMove { itemId: string; bagId: string }
export function applyBagMoves(state: PackingState, moves: BagMove[]) { return moves.reduce((next, move) => assignItemToBag(next,move.itemId,move.bagId),state); }
export function suggestSharedSplit(state: PackingState): BagMove[] {
  if (state.bags.length < 2) return [];
  const shared = state.items.filter((item) => item.ownerId === 'shared').sort((a,b)=>(b.weightG ?? 0)-(a.weightG ?? 0));
  let next = shared.reduce((next,item)=>assignItemToBag(next,item.id,undefined),state);
  const moves: BagMove[] = [];
  for (const item of shared) {
    const eligible = state.bags.filter((bag) => canSuggestBag(item, bag));
    if (!eligible.length) { next = assignItemToBag(next, item.id, item.assignedBagId); continue; }
    const loads = deriveBagLoads(next).filter((load) => eligible.some((bag) => bag.id === load.bagId));
    const ranked = [...loads].sort((a,b) => {
      // Shared allowance group is one limit, never divide it into fictional per-bag limits.
      const score = (load: typeof a) => load.allowanceG !== undefined && !load.unknownItems && item.weightG !== undefined ? load.totalWeightG-load.allowanceG : load.totalWeightG;
      return score(a)-score(b) || a.bagId.localeCompare(b.bagId);
    });
    const destination = item.weightG === undefined ? [...eligible].sort((a,b)=>next.items.filter((i)=>i.assignedBagId===a.id).length-next.items.filter((i)=>i.assignedBagId===b.id).length)[0]!.id : ranked[0]!.bagId;
    moves.push({itemId:item.id,bagId:destination}); next=assignItemToBag(next,item.id,destination);
  }
  return moves;
}
export function suggestRelief(state: PackingState, bagId: string): BagMove[] {
  const loads = deriveBagLoads(state), source = loads.find((load)=>load.bagId===bagId);
  if (!source?.overweight || source.unknownItems) return [];
  return state.items.filter((item)=>item.assignedBagId===bagId && item.weightG!==undefined).sort((a,b)=>b.weightG!-a.weightG!).flatMap((item)=>{
    const destination = loads.find((load)=>load.bagId!==bagId && canSuggestBag(item, state.bags.find((bag)=>bag.id===load.bagId)!) && load.remainingG!==undefined && load.remainingG>=item.weightG! && (!source.allowanceGroupId || load.allowanceGroupId!==source.allowanceGroupId));
    return destination ? [{itemId:item.id,bagId:destination.bagId}] : [];
  }).slice(0,3);
}
